import type { Catalog, FilterLocation, Maybe } from '@/types'
import type { SingleProductFilter } from '@/types/ui'
import { DiscountedOptions, ProductsSortOptions } from '@/types'

export const LABEL_TYPE_TITLES: Record<string, string> = {
  new: 'Новинка',
  sale: 'Распродажа',
  out_of_stock: 'Нет в наличии',
  collab: 'Коллаборация',
}

export const FILTER_SOURCES = [
  {
    id: 'local',
    name: 'Данные сайта',
    listKey: 'filtersFunctions',
    itemKey: 'function',
    fieldKey: 'function',
  },
  {
    id: 'moysklad',
    name: 'Мой склад',
    listKey: 'options',
    itemKey: 'id',
    fieldKey: 'option_id',
  },
]

export const FILTER_LOCATIONS: { alias: FilterLocation; name: string }[] = [
  { alias: 'storefront', name: 'Витрина' },
  { alias: 'products', name: 'CMS: товары' },
  { alias: 'presets', name: 'CMS: кружки-фильтры' },
]

export const VARIANTS_OPTIONS = [
  { id: null, name: '' },
  { id: 2, name: '2+' },
  { id: 3, name: '3+' },
  { id: 4, name: '4+' },
  { id: 5, name: '5+' },
]

export const SINGLE_PRODUCT_FILTER: SingleProductFilter = {
  brand: null,
  category: null,
  variantsCount: null,
}

export const SORT_TYPE: { alias: Catalog['merch']['type']; name: string }[] = [
  { alias: 'groups', name: 'Разделять товары группами по категориям' },
  { alias: 'sort', name: 'Задать сортировку' },
]

export const BY_GROUP_OPTION = { alias: 'groups', name: 'Заполнять группами' }

export const MANAGER_PRODUCTS_SORT_OPTIONS: {
  alias: ProductsSortOptions
  name: string
}[] = [
  { alias: ProductsSortOptions.StockAsc, name: 'Остаток: по возрастанию' },
  { alias: ProductsSortOptions.StockDesc, name: 'Остаток: по убыванию' },
  { alias: ProductsSortOptions.PriceAsc, name: 'Цена: по возрастанию' },
  { alias: ProductsSortOptions.PriceDesc, name: 'Цена: по убыванию ' },
  {
    alias: ProductsSortOptions.DiscountAsc,
    name: 'Размер скидки: от меньшей к большей',
  },
  {
    alias: ProductsSortOptions.DiscountDesc,
    name: 'Размер скидки: от большей к меньшей',
  },
]

export const MANAGER_CATALOG_SHOW_DISCOUNTED_OPTIONS: {
  alias: DiscountedOptions
  name: string
}[] = [
  { alias: DiscountedOptions.Hide, name: 'Скрывать товары со скидками' },
  { alias: DiscountedOptions.Show, name: 'Показывать товары со скидками' },
  {
    alias: DiscountedOptions.Only,
    name: 'Показывать только товары со скидками',
  },
]

export const CUSTOMER_PRODUCTS_SORT_OPTIONS: {
  alias: Maybe<ProductsSortOptions>
  name: string
}[] = [
  { alias: null, name: 'По умолчанию' },
  { alias: ProductsSortOptions.PriceDesc, name: 'По убыванию цены' },
  { alias: ProductsSortOptions.PriceAsc, name: 'По возрастанию цены' },
]
